
import { defineComponent, ref, onMounted } from "vue";
import JwtService from "@/core/services/JwtService";
import ApiService from "@/core/services/ApiService";
import Notice from "@/components/Notice.vue";
import { statusColor, translate } from "@/core/services/HelpersFun";
import { ElNotification } from "element-plus/es";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default defineComponent({
  name: "multiple-messages",
  components: {
    Notice,
  },
  emits: ["getSelectedBot", "size-change", "handleSizeChange", "setGif"],
  setup() {
    const store = useStore();
    const loading = ref(true);
    const list = ref();
    const sendMessageRef = ref();
    const pagination = ref();
    const page = ref(1);

    const getItems = () => {
      loading.value = true;
      ApiService.setHeader();
      ApiService.get("/questionnaires").then(({ data }) => {
        loading.value = false;
        list.value = data.data.questionnaires;
        pagination.value = data.data.pagination;
      });
    };

    const excelLink = (id) => {
      return (
        process.env.VUE_APP_UPLOAD_FILE_URL +
        `/message/${id}/report/download?api_token=${JwtService.getToken()}`
      );
    };

    const handleSizeChange = (val: number) => {
      return;
    };
    const handleCurrentChange = (val: number) => {
      page.value = val;
      getItems();
    };

    onMounted(() => {
      getItems();
    });

    const removeQuestionnaire = (item) => {
      ApiService.post(`bot/${item.bot.bot_id}/bot-menu/delete-secretary`, {
        tag: item.name,
      })
        .then(() => {
          getItems();
        })
        .catch((e) => {
          store.commit(Mutations.SET_ERROR, e.response.data);
          let error = e.response.data.message;
          ElNotification({
            title: "خطا",
            message: error,
            type: "error",
          });
        });
    };

    const activeQuestionnaire = (item) => {
      Swal.fire({
        title:
          "توجه داشته باشید که در صورت فعال سازی اگر پاسخگوی‌خودکار فعالی داشته باشید غیر فعال شده و این پرسشنامه به عنوان پاسخگوی‌خودکار فعال در شماره فعال خواهد گردید.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "بله, متوجه شدم.",
        denyButtonText: "نه, ممنون",
        icon: "warning",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap",
          confirmButton: "order-2",
          denyButton: "order-3",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.post(`bot/${item.bot.bot_id}/change-tag`, {
            tag: item.name,
          })
            .then(() => {
              getItems();
              ElNotification({
                title: "انجام شد",
                message: "عملیات با موفقیت انجام شد.",
                type: "success",
              });
            })
            .catch((response) => {
              store.commit(Mutations.SET_ERROR, response.data);
              ElNotification({
                title: "خطا",
                message: "خطا در انجام عملیات",
                type: "error",
              });
            });
        }
      });
    };

    return {
      list,
      loading,
      excelLink,
      pagination,
      handleCurrentChange,
      handleSizeChange,
      page,
      getItems,
      removeQuestionnaire,
      activeQuestionnaire,
      sendMessageRef,
      statusColor,
      translate,
    };
  },
});
